import dayjs from "dayjs";

import { dayMilliseconds } from "web/constants/date";

import { IProductCode } from "web/types/Code";

const availabilityMap = {
  used: 1,
  use: 0,
};

const canceledPaymentStatuses = [
  "PARTIALLY_CANCELLED",
  "TO_MANUALLY_CANCEL",
  "CANCELED",
  "CANCEL_ERROR",
  "TO_CANCEL",
] as const;

export const enum FilterValues {
  USE = "use",
  USED = "used",
  ALL = "all",
  CANCELED = "canceled",
}

export const getFilters = (value: FilterValues) => {
  return value
    ? [
        {
          ...(value === FilterValues.USE || value === FilterValues.USED
            ? {
                filters: [
                  {
                    field: "product_user_used",
                    value: availabilityMap[value],
                  },
                ],
              }
            : {}),
        },
        {
          ...(value === FilterValues.USE
            ? {
                filters: [
                  {
                    field: "product_expiration_date",
                    value: dayjs(Date.now() + dayMilliseconds).format(
                      "YYYY-MM-DD"
                    ),
                    conditionType: "gt",
                  },
                ],
              }
            : {}),
        },
        {
          ...(value === FilterValues.CANCELED
            ? {
                filters: canceledPaymentStatuses.map((status) => ({
                  field: "payment_status",
                  value: status,
                })),
              }
            : {}),
        },
        {
          ...(value !== FilterValues.ALL && value !== FilterValues.CANCELED
            ? {
                filters: [
                  { field: "product_code_status", value: "claim_success" },
                ],
              }
            : {}),
        },
      ]
    : null;
};

export const transformSplittedCode = (
  splittedCode: IProductCode["splittedCode"]
) => {
  if (!splittedCode) return null;

  if (Array.isArray(splittedCode)) {
    return splittedCode.map((line) => ({
      name: line.name?.endsWith(":") ? line.name?.slice(0, -1) : line.name,
      value: line.value,
    }));
  }

  return [
    splittedCode.pierwsza_linijka_pod_kodem_kreskowym,
    splittedCode.druga_linijka_pod_kodem_kreskowym,
    splittedCode.trzecia_linijka_pod_kodem_kreskowym,
    splittedCode.czwarta_linijka_pod_kodem_kreskowym,
    splittedCode.piata_linijka_pod_kodem_kreskowym,
  ].filter(Boolean);
};
